import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import InternshipTrainingPrograms from '../InternshipTrainingPrograms/InternshipTrainingPrograms'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Internship & Training Programs" />
                <InternshipTrainingPrograms />
                <Footer />
            </div>
        </>
    )
}

export default Main